import { render } from "./ComposeSms.vue?vue&type=template&id=108c0f6c&scoped=true"
import script from "./ComposeSms.vue?vue&type=script&lang=js"
export * from "./ComposeSms.vue?vue&type=script&lang=js"

import "./ComposeSms.vue?vue&type=style&index=0&id=108c0f6c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-108c0f6c"]])

export default __exports__